export default "__VITE_ASSET__B0jd9hbi__"